import { matchPath, useLocation } from 'react-router-dom';

import { ROUTES } from 'configs/routes';

const DOCUMENT_SCROLL_PATHS = [ROUTES.lk.projects.detail.path, ROUTES.lk.about.path];

/** Определяет, использует ли текущий маршрут прокрутку документа вместо внутренней области layout. */
export const useDocumentScroll = (): boolean => {
  const { pathname } = useLocation();

  return DOCUMENT_SCROLL_PATHS.some((path) => matchPath({ path, end: true }, pathname));
};
